(function () {
  const SWATCH_IMAGES = {
    alyssa:  "https://arthurcameron.co.uk/cdn/shop/files/alyssa.jpg?v=1771328553",
    arvind:  "https://arthurcameron.co.uk/cdn/shop/files/arvind.jpg?v=1771327270",
    aster:   "https://arthurcameron.co.uk/cdn/shop/files/aster.jpg?v=1771327321",
    bloem:   "https://arthurcameron.co.uk/cdn/shop/files/bloem.jpg?v=1771326943",
    farlow:  "https://arthurcameron.co.uk/cdn/shop/files/farlow.jpg?v=1771327346",
    fio:     "https://arthurcameron.co.uk/cdn/shop/files/fio.jpg?v=1771327418",
    fiore:   "https://arthurcameron.co.uk/cdn/shop/files/fiore.jpg?v=1771327294",
    flor:    "https://arthurcameron.co.uk/cdn/shop/files/flor.jpg?v=1771327392",
    hadden:  "https://arthurcameron.co.uk/cdn/shop/files/hadden.jpg?v=1771327404",
    huxlee:  "https://arthurcameron.co.uk/cdn/shop/files/huxlee.jpg?v=1771327308",
    joris:   "https://arthurcameron.co.uk/cdn/shop/files/joris.jpg?v=1771327357",
    kukka:   "https://arthurcameron.co.uk/cdn/shop/files/kukka.jpg?v=1771327368",
    nalin:   "https://arthurcameron.co.uk/cdn/shop/files/nalin.jpg?v=1771327429",
    palesa:  "https://arthurcameron.co.uk/cdn/shop/files/palesa.jpg?v=1771403944",
    puawai:  "https://arthurcameron.co.uk/cdn/shop/files/puawai.jpg?v=1771326983",
    westley: "https://arthurcameron.co.uk/cdn/shop/files/westley.jpg?v=1771327281"
  };

  function applySwatches(root) {
    const scope = root || document;

    // ✅ Broader selector: catches desktop + sidebar + rebuilt DOM
    const nodes = scope.querySelectorAll(".filter-swatch .swatch__value[class*='bg_color_'], .filter-swatch .swatch_value[class*='bg_color_']");

    let applied = 0;

    nodes.forEach((el) => {
      const cls = Array.from(el.classList).find(c => c.startsWith("bg_color_"));
      if (!cls) return;

      const key = cls.replace("bg_color_", "");
      const url = SWATCH_IMAGES[key];
      if (!url) return;

      el.style.setProperty("background-image", `url("${url}")`, "important");
      el.style.setProperty("background-size", "cover", "important");
      el.style.setProperty("background-position", "center", "important");
      el.style.setProperty("background-repeat", "no-repeat", "important");
      el.style.setProperty("background-color", "transparent", "important");

      applied++;
    });

    if (applied) console.log("[Swatches] applied:", applied);
    return applied;
  }

  // ✅ Makes it testable in Console
  window.applySwatchImages = function () {
    return applySwatches(document);
  };

  function boot() {
    // Apply immediately
    applySwatches(document);

    // Apply again after common Kalles redraw timings
    [200, 600, 1200, 2000, 3500].forEach(ms => {
      setTimeout(() => applySwatches(document), ms);
    });

    // Observe redraws (Kalles replaces swatch nodes)
    const obs = new MutationObserver(() => applySwatches(document));
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();